/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';

/**
 * 
 * @export
 * @interface GetUserInCompanyDto
 */
export interface GetUserInCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserInCompanyDto
     */
    id: string;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetUserInCompanyDto
     */
    company?: GetCompanyDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetUserInCompanyDto
     */
    user?: GetUserDto | null;
}

/**
 * Check if a given object implements the GetUserInCompanyDto interface.
 */
export function instanceOfGetUserInCompanyDto(value: object): value is GetUserInCompanyDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetUserInCompanyDtoFromJSON(json: any): GetUserInCompanyDto {
    return GetUserInCompanyDtoFromJSONTyped(json, false);
}

export function GetUserInCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserInCompanyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'company': json['company'] == null ? undefined : GetCompanyDtoFromJSON(json['company']),
        'user': json['user'] == null ? undefined : GetUserDtoFromJSON(json['user']),
    };
}

export function GetUserInCompanyDtoToJSON(value?: GetUserInCompanyDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'company': GetCompanyDtoToJSON(value['company']),
        'user': GetUserDtoToJSON(value['user']),
    };
}

